export default __webpack_public_path__ + "static/media/convention18.00dc5248.png";